import { render, staticRenderFns } from "./user_roles_admin.vue?vue&type=template&id=75cdc8da&"
import script from "./user_roles_admin.vue?vue&type=script&lang=js&"
export * from "./user_roles_admin.vue?vue&type=script&lang=js&"
import style0 from "./user_roles_admin.vue?vue&type=style&index=0&id=75cdc8da&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports